<div class="cads-account-balance">
  <div class="cads-account-balance__top">
    <div class="cads-account-balance__amount">
      <cads-labeled-amount-bit [config]="_labeledAmountConfig()" />
    </div>
    @if (_hasBadges()) {
      <div class="cads-account-balance__badges">
        @for (badge of _badges(); track $index) {
          <cads-badge-bit [config]="badge" />
        }
      </div>
    }
  </div>
</div>
